import { cn } from "../../lib/utils.ts";

export const ZoomIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      role="img"
      aria-label="Zoom"
      className={cn(className)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#zoom-clip)">
        <path
          d="M20 10C20 11.0694 19.914 12.118 19.7498 13.1404C19.2062 16.5251 16.5251 19.2062 13.1403 19.7498C12.1179 19.9141 11.0693 20 10 20C8.9307 20 7.88212 19.9141 6.85967 19.7498C3.47494 19.2062 0.793814 16.5251 0.250179 13.1404C0.0859643 12.1179 0 11.0694 0 10C0 8.93065 0.0859643 7.88207 0.250179 6.85965C0.793821 3.47491 3.47494 0.793801 6.85968 0.250179C7.88213 0.0859644 8.93071 0 10 0C11.0693 0 12.1179 0.0859644 13.1403 0.250179C16.5251 0.793801 19.2062 3.47491 19.7498 6.85964C19.914 7.88207 20 8.93065 20 10Z"
          fill="#0B5CFF"
        />
        <path
          d="M12.1429 12.5001C12.1429 13.0918 11.6632 13.5716 11.0715 13.5716H6.42862C5.24515 13.5716 4.28577 12.6122 4.28577 11.4287V7.50014C4.28577 6.90845 4.76546 6.42871 5.3572 6.42871H10.0001C11.1835 6.42871 12.1429 7.3881 12.1429 8.57157V12.5001ZM14.8572 7.0715L13.2858 8.25008C13.016 8.45243 12.8572 8.76999 12.8572 9.10724L12.8572 10.893C12.8572 11.2302 13.016 11.5477 13.2858 11.7501L14.8572 12.9287C15.2104 13.1935 15.7143 12.9415 15.7143 12.5001V7.50008C15.7143 7.05863 15.2104 6.80663 14.8572 7.0715Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="zoom-clip">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
